"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notation = void 0;
var react_1 = __importDefault(require("react"));
var Modifiers_1 = require("./Modifiers");
var SubSection_1 = require("./SubSection");
var Notation = function (_a) {
    var base = _a.base, numbers = _a.numbers, values = _a.values;
    return (react_1.default.createElement(SubSection_1.SubSection, { title: "Notation" },
        react_1.default.createElement("p", { className: "f3 mb1 mt2" }, "Structure"),
        react_1.default.createElement("p", null, "".concat(base).concat(values === undefined ? "" : "-<value>").concat(numbers === undefined ? "" : "<number>")),
        react_1.default.createElement(Modifiers_1.Modifiers, { modifiers: values, title: "Values" }),
        react_1.default.createElement(Modifiers_1.Modifiers, { modifiers: numbers, title: "Numbers" })));
};
exports.Notation = Notation;
